export default __webpack_public_path__ + "locales/pl/Settings.json?hash=f6f9f77b6c8dd01b2ff79cca7ecc424a";